import { render, staticRenderFns } from "./ChatbotsList.vue?vue&type=template&id=bdc84d98&scoped=true&"
import script from "./ChatbotsList.vue?vue&type=script&lang=js&"
export * from "./ChatbotsList.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotsList.vue?vue&type=style&index=0&id=bdc84d98&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc84d98",
  null
  
)

export default component.exports